import React, { useState, useEffect, Fragment } from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { EmojiTitleStateContainer } from '@confluence/emoji-title/entry-points/emojiTitleStateContainer.ts';
import { CoverPictureStateContainer } from '@confluence/page-cover-picture/entry-points/CoverPictureStateContainer.ts';
import { ContentStateStateContainer } from '@confluence/content-state/entry-points/ContentStateStateContainer.ts';

// Utility component to update state when subscription triggers.
// We can't call state setters in Subscribe's render prop because it's called in the render phase.
const StateSync = ({ value, setter }: { value: boolean; setter: (value: boolean) => void }) => {
	useEffect(() => {
		setter(value);
	}, [value, setter]);
	return null;
};

export const useEmojiTitleCoverPictureAndContentState = (): {
	emojiCoverPictureAndContentStateSubscription: React.JSX.Element;
	hasCoverPicture: boolean;
	hasEmoji: boolean;
	hasContentState: boolean;
} => {
	const [hasEmoji, setHasEmoji] = useState<boolean>(false);
	const [hasCoverPicture, setHasCoverPicture] = useState<boolean>(false);
	const [hasContentState, setHasContentState] = useState<boolean>(false);

	const emojiCoverPictureAndContentStateSubscription = (
		<Fragment>
			<Subscribe to={[EmojiTitleStateContainer]}>
				{(emojiTitleState: EmojiTitleStateContainer) => (
					<StateSync value={!!emojiTitleState.state.selectedEmoji} setter={setHasEmoji} />
				)}
			</Subscribe>
			<Subscribe to={[CoverPictureStateContainer]}>
				{(coverPictureState: CoverPictureStateContainer) => (
					<StateSync value={coverPictureState.state.hasCoverPicture} setter={setHasCoverPicture} />
				)}
			</Subscribe>
			<Subscribe to={[ContentStateStateContainer]}>
				{(contentStateState: ContentStateStateContainer) => (
					<StateSync value={!!contentStateState.state.contentState} setter={setHasContentState} />
				)}
			</Subscribe>
		</Fragment>
	);

	return {
		emojiCoverPictureAndContentStateSubscription,
		hasCoverPicture,
		hasEmoji,
		hasContentState,
	};
};
